import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EmailTemplate } from '../types/interfaces/email-template';

@Injectable({
  providedIn: 'root',
})
export class EmailsMaintenanceService {
  private baseUrl = `${environment.apiHost}/maintenance/email-templates`;

  constructor(private http: HttpClient) {}

  getEmailOptions(): Observable<EmailTemplate[]> {
    return this.http.get<EmailTemplate[]>(this.baseUrl, {
      withCredentials: true,
    });
  }

  public addEmailOptions(email: EmailTemplate): Observable<EmailTemplate> {
    return this.http.post<EmailTemplate>(this.baseUrl, email, {
      withCredentials: true,
    });
  }

  public updateEmailOption(email: EmailTemplate): Observable<EmailTemplate> {
    return this.http.put<EmailTemplate>(this.baseUrl + `/${email.id}`, email, {
      withCredentials: true,
    });
  }

  public deleteEmailOption(emailId: number): Observable<EmailTemplate> {
    return this.http.delete<EmailTemplate>(this.baseUrl + `/${emailId}`, {
      withCredentials: true,
    });
  }
}
